import { render, staticRenderFns } from "./MonitorageJeux.vue?vue&type=template&id=41dedcd6&scoped=true"
import script from "./MonitorageJeux.vue?vue&type=script&lang=js"
export * from "./MonitorageJeux.vue?vue&type=script&lang=js"
import style0 from "./MonitorageJeux.vue?vue&type=style&index=0&id=41dedcd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dedcd6",
  null
  
)

export default component.exports